import moment from 'moment/moment';
import { bigNumberToText } from '../../../../../components/utils';
import React from 'react';

const xAxisFormatter = (timestamp: moment.Moment | string) => {
    return typeof timestamp === 'object' ? timestamp.format('MMMM') : moment(timestamp).format('MMMM');
};

const yAxisFormatter = (count: number) => {
    return bigNumberToText(count, false, 0);
};

const getXAxisTicks = (startDate: moment.Moment, endDate: moment.Moment) => {
    const monthsBetween: moment.Moment[] = [];

    if (startDate < endDate) {
        monthsBetween.push(startDate.clone());

        const date = startDate.startOf('month');
        date.add(1, 'month');

        while (date < endDate.endOf('month')) {
            monthsBetween.push(date.clone());
            date.add(1, 'month');
        }
    }

    return monthsBetween;
};

const AREA_FILL_COLOR_DEFINITION_IDENTIFIER = 'chartFillColor';

const AREA_FILL_COLOR_DEFINITION = (
    <defs>
        <linearGradient
            id={AREA_FILL_COLOR_DEFINITION_IDENTIFIER}
            x1="220.413"
            y1="-281.989"
            x2="220.413"
            y2="101.711"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#0E7FDC" />
            <stop offset="1" stopColor="#69A9EE" stopOpacity="0.1" />
        </linearGradient>
    </defs>
);

export {
    xAxisFormatter,
    yAxisFormatter,
    getXAxisTicks,
    AREA_FILL_COLOR_DEFINITION,
    AREA_FILL_COLOR_DEFINITION_IDENTIFIER
};
